import { jsx } from 'react/jsx-runtime';
import './InputNumber-7d93e963.js';
import './components/shared/Link.es.js';
import 'tslib';
import 'rc-select';
import '@teko-builder/icons';
import './FormItem-098fa619.js';
import '@teko-builder/types/pb';
import './text-21866551.js';
import './DateTimePickerMobile-749dc497.js';
import './RadioGroup-4b4abf08.js';
import './Col-475038db.js';
import { D as DSSlider } from './Slider-93041044.js';
import './Container-ca9f82d8.js';
import './Divider-600cb92e.js';
import './Ripple-abf0f8a0.js';
import './Image-efa43cf5.js';
import './ModalHeader-a3d30e4f.js';
import './Spin-a6892495.js';
import { c as convertOptionSliderV2ToV1 } from './slider-28e133c3.js';
import React from 'react';
import styled from '@emotion/styled';
import { getStyle } from './utils.es.js';

const ContentSlider = (props) => {
    return (jsx(DSSlider, Object.assign({}, convertOptionSliderV2ToV1(props), { children: props.children })));
};
ContentSlider.displayName = 'ContentSlider';

const ContentSliderItem = React.forwardRef(({ children, commonStyle }, ref) => {
    return (jsx(StyledDiv, Object.assign({ commonStyle: commonStyle, ref: ref }, { children: children })));
});
const StyledDiv = styled.div(({ commonStyle }) => `
    ${getStyle(commonStyle)}
  `);
ContentSliderItem.displayName = 'ContentSliderItem';

export { ContentSlider as C, ContentSliderItem as a };
